import React, { useState } from "react";
import "./styles.css";

const tabs = ["Chat", "Records", "Bookmark", "Summary"];

export default function App() {
  const [activeTab, setActiveTab] = useState("Chat");
  const [messages, setMessages] = useState([
    { id: 1, from: "ai", text: "Hello! How can I assist you today?" }
  ]);
  const [loading, setLoading] = useState(false);

  async function sendMessageToDify(userMessage) {
    setLoading(true);

    const apiKey = "1111xxxx0000"; // 伏字でOK
    const endpoint = "https://localvps02.xvps.jp/v1/chat-messages";

    try {
      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiKey}`
        },
        body: JSON.stringify({
          inputs: {},
          query: userMessage,
          user: "user_001"
        })
      });

      const data = await response.json();

      const aiMessage = data.answer ?? "(no response)";

      setMessages((prev) => [
        ...prev,
        { id: Date.now(), from: "ai", text: aiMessage }
      ]);
    } catch (err) {
      setMessages((prev) => [
        ...prev,
        { id: Date.now(), from: "ai", text: "Error: " + err.message }
      ]);
    }

    setLoading(false);
  }

  return (
    <div className="app-root">
      <TopBar />

      <div className="app-body">
        <Sidebar />

        <main className="main-panel">
          <ChatHeader />

          <Tabs activeTab={activeTab} onChange={setActiveTab} />

          <div className="tab-content">
            {activeTab === "Chat" && (
              <ChatWindow messages={messages} loading={loading} />
            )}
            {activeTab !== "Chat" && (
              <Placeholder title={activeTab} />
            )}
          </div>

          <ChatInput
            onSend={(text) => {
              setMessages((prev) => [
                ...prev,
                { id: Date.now(), from: "user", text }
              ]);
              sendMessageToDify(text);
            }}
          />
        </main>

        <RightPanel />
      </div>
    </div>
  );
}

/* ---------- Top Bar ---------- */

function TopBar() {
  return (
    <header className="topbar">
      <div className="topbar-left">
        <span className="logo-text">Tax AI Dashboard</span>
      </div>
      <div className="topbar-center">
        <div className="search-box">
          <span className="search-icon">🔍</span>
          <input placeholder="Search" />
        </div>
      </div>
      <div className="topbar-right">
        <button className="icon-btn">🔔</button>
        <button className="avatar-btn">
          <span className="avatar-circle">A</span>
        </button>
      </div>
    </header>
  );
}

/* ---------- Sidebar ---------- */

function Sidebar() {
  return (
    <aside className="sidebar">
      <nav>
        <div className="sidebar-section-title">Navigation</div>

        <SidebarItem label="Chat Rooms" active />
        <SidebarItem label="Chat Rooms by Client" />
        <SidebarItem label="Bookmarks" />
        <SidebarItem label="Records" />
        <SidebarItem label="Settings" />
      </nav>
    </aside>
  );
}

function SidebarItem({ label, active }) {
  return (
    <button className={`sidebar-item ${active ? "sidebar-item--active" : ""}`}>
      {label}
    </button>
  );
}

/* ---------- Main Chat Panel ---------- */

function ChatHeader() {
  return (
    <div className="chat-header">
      <h2>AI Chat</h2>
      <span className="chat-subtitle">
        Ask the AI assistant about tasks, clients, and schedules.
      </span>
    </div>
  );
}

function Tabs({ activeTab, onChange }) {
  return (
    <div className="tabs">
      {tabs.map((tab) => (
        <button
          key={tab}
          className={`tab-item ${activeTab === tab ? "tab-item--active" : ""}`}
          onClick={() => onChange(tab)}
        >
          {tab}
        </button>
      ))}
    </div>
  );
}

function ChatWindow({ messages, loading }) {
  return (
    <div className="chat-window">
      {messages.map((msg) => (
        <ChatBubble key={msg.id} from={msg.from} text={msg.text} />
      ))}

      {loading && <div className="chat-bubble-row">⏳ Loading...</div>}
    </div>
  );
}

function ChatBubble({ from, text }) {
  const isAI = from === "ai";
  return (
    <div
      className={`chat-bubble-row ${
        isAI ? "chat-bubble-row--ai" : "chat-bubble-row--user"
      }`}
    >
      <div className={`chat-bubble ${isAI ? "chat-bubble--ai" : "chat-bubble--user"}`}>
        {text}
      </div>
    </div>
  );
}

function ChatInput({ onSend }) {
  const [text, setText] = useState("");

  return (
    <div className="chat-input-bar">
      <input
        className="chat-input"
        placeholder="Send a message..."
        value={text}
        onChange={(e) => setText(e.target.value)}
      />
      <button
        className="primary-btn"
        onClick={() => {
          if (!text.trim()) return;
          onSend(text);
          setText("");
        }}
      >
        Send
      </button>
    </div>
  );
}

/* ---------- Placeholder for other tabs ---------- */

function Placeholder({ title }) {
  return (
    <div className="placeholder">
      <p>{title} view will be implemented here.</p>
    </div>
  );
}

/* ---------- Right Panel ---------- */

function RightPanel() {
  return (
    <aside className="right-panel">
      <section className="panel-card">
        <h3>Work Evaluation</h3>
        <div className="evaluation-wrapper">
          <div className="evaluation-circle">
            <span>84</span>
          </div>
          <div className="evaluation-text">
            <div className="evaluation-label">Today’s performance score</div>
            <div className="evaluation-desc">Stable workload and on track.</div>
          </div>
        </div>
      </section>

      <section className="panel-card">
        <h3>Schedule Suggestions</h3>
        <div className="tasks-list">
          <div className="tasks-title">Today’s Tasks</div>
          <ul>
            <li>Review tax return for Client A</li>
            <li>Prepare quarterly report for Client B</li>
            <li>Check missing documents for Client C</li>
          </ul>
        </div>
        <MiniChart />
      </section>
    </aside>
  );
}

function MiniChart() {
  return (
    <div className="mini-chart">
      <svg viewBox="0 0 100 40" preserveAspectRatio="none">
        <polyline
          className="mini-chart-area"
          points="0,35 0,25 25,20 50,28 75,15 100,22 100,35"
        />
        <polyline
          className="mini-chart-line"
          points="0,25 25,20 50,28 75,15 100,22"
        />
        <circle cx="0" cy="25" r="1.8" />
        <circle cx="25" cy="20" r="1.8" />
        <circle cx="50" cy="28" r="1.8" />
        <circle cx="75" cy="15" r="1.8" />
        <circle cx="100" cy="22" r="1.8" />
      </svg>
    </div>
  );
}
